import { Card, Stack, TableHead, TableRow, TableCell, TableBody, Table } from '@mui/material';
import { useNavigate } from 'react-router';

import { StatusTag } from '../status-tag';
import { Scrollbar } from '../scrollbar';
import { Strings } from '@app/constants';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { DataNotFound } from '../page-404';

interface Props {
  title?: string;
  height?: number;
  data?: any;
  rows?: any;
}

const DashboardDetailsCard = ({ title, height, data, rows }: Props) => {
  const navigate = useNavigate();
  return (
    <Card
      sx={{
        mb: 2,
        borderRadius: '5px',
        height,
        width: { md: '100%', sm: '96%' },
        ml: { xs: 1, md: 0 },
        mr: { xs: 1 },
      }}
    >
      <Stack fontSize={17} fontWeight={700} p={1.5}>
        {title}
      </Stack>
      <Scrollbar
        sx={{
          height: 280,
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
          '-ms-overflow-style': 'none',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {rows ? Strings.field.name : Strings.assets.serialNumber}
              </TableCell>
              <TableCell align="center">
                {rows ? Strings.field.email : Strings.assets.assetName}
              </TableCell>
              <TableCell align="center">{Strings.field.status}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(() => {
              const tableData = Array.isArray(rows) && rows.length > 0 ? rows : data;
              const isClient = tableData === rows;

              if (!Array.isArray(tableData) || tableData.length === 0) {
                return (
                  <TableRow>
                    <TableCell colSpan={3} style={{ borderBottom: 0 }}>
                      <DataNotFound height={190} />
                    </TableCell>
                  </TableRow>
                );
              }

              return tableData.map((row: any, index: number) => {
                const openDetailsPage = () => {
                  navigate(
                    isClient
                      ? `${PATH_DASHBOARD.clientDetail}/${row?.firstName as string}`
                      : PATH_DASHBOARD.assetsDetail,
                    { state: { id: row.id } }
                  );
                };

                return (
                  <TableRow key={index}>
                    <TableCell align="center" onClick={openDetailsPage}>
                      {isClient ? row.firstName : row.serialNumber}
                    </TableCell>
                    <TableCell align="center" onClick={openDetailsPage}>
                      {isClient ? row.email : row.assetName}
                    </TableCell>
                    <TableCell align="center" onClick={openDetailsPage}>
                      <StatusTag
                        status={
                          isClient ? (row.status === true ? 'Active' : row.status) : row.status
                        }
                      />
                    </TableCell>
                  </TableRow>
                );
              });
            })()}
          </TableBody>
        </Table>
      </Scrollbar>
    </Card>
  );
};

export { DashboardDetailsCard };
